<a
    class="!z-[950] w-full flex flex-col items-center justify-center rounded-lg cursor-pointer hover:bg-p-content-hover-background"
    [ngClass]="{ '!bg-primary-50 dark:!bg-primary': menuDrawerStateService.visible() }"
    (click)="onClickToggleMenu()"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
    pTooltip="Menu"
    tooltipPosition="top">
    @if (menuDrawerStateService.visible()) {
        <fa-icon class="text-[20px] text-primary dark:text-white" [icon]="faBarsSolid" />
    } @else {
        <fa-icon class="text-[20px] text-color" [icon]="faBars" />
    }
</a>

<p-drawer
    class="h-full !z-[900]"
    [visible]="menuDrawerStateService.visible()"
    position="full"
    [modal]="true"
    [dismissible]="true"
    maskStyle="background-color:transparent !important"
    [autoZIndex]="false"
    styleClass="!z-[900]">
    <ng-template #headless>
        <fm-mobile-menu class="!z-[900]" (menuItemClicked)="onMenuItemClicked()" />
    </ng-template>
</p-drawer>
